import { jsx as _jsx } from "react/jsx-runtime";
import { useBrandConfiguration } from '@search/core/brands/context';
import { BaseCard } from '@search/core/components/BaseCard/BaseCard';
import { getQueryString } from '@search/core/helpers/getQueryString';
import { CardListName, SerpView, useCardClick } from '@search/core/hooks/useCardClick';
import { useAppContext } from '../../contexts/AppContext';
export const Card = ({ id, index, ...props }) => {
    const { defaultOrder } = useBrandConfiguration();
    const [searchModel, page, order] = useAppContext((store) => [store.searchModel, store.page, store.order]);
    const queryString = searchModel ? getQueryString({ searchModel, page, order }, defaultOrder) : '';
    const trackingEvent = searchModel && useCardClick({ id, trackingName: CardListName.SERP, searchModel, index, isCardXXL: props.isCardXXL });
    return (_jsx(BaseCard, { id: id, queryString: queryString, listName: CardListName.SERP, serpView: SerpView.SERP, trackingEvent: trackingEvent, ...props }));
};
